import * as tslib_1 from "tslib";
import { common } from './common';
export var environment = tslib_1.__assign({}, common, { name: 'prod', production: true, isDebugMode: false, apiURL: '', appPath: '/jwt/', appUrl: '', appRealm: 'TRAMIT-TEL' });
